import { render, staticRenderFns } from "./GlobalOrder.vue?vue&type=template&id=6880e8be&scoped=true&"
import script from "./GlobalOrder.vue?vue&type=script&lang=js&"
export * from "./GlobalOrder.vue?vue&type=script&lang=js&"
import style0 from "./GlobalOrder.vue?vue&type=style&index=0&id=6880e8be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6880e8be",
  null
  
)

export default component.exports